<template>
  <!-- ======================================= 회원 현황 ======================================= -->
  <b-row>
    <b-col sm="12">
      <b-card class="status-card">
        <b-row>
          <b-col sm="1">
            <span class="card-title wise-card-title">회원현황 </span>
          </b-col>
          <b-col sm="10">
            <!-- 로딩 -->
            <b-row v-show="statusLoding">
              <b-col sm="5"></b-col>
              <b-col sm="5" class="pt-4 pb-4">
                <PulseLoader color="#20a8d8"></PulseLoader>
              </b-col>
            </b-row>
            <b-row v-show="!statusLoding">
              <b-col sm="3">
                <div class="callout callout-info">
                  <span class="text-muted" style="font-size: 15px"
                    >활성회원</span
                  >
                  <br />
                  <strong class="h4">{{
                    (userStatistics.user_active_Count - userStatistics.user_company_Count)
                      | numberComma
                  }}</strong>
                </div>
              </b-col>
              <b-col sm="3">
                <div class="callout callout-success">
                  <span class="text-muted" style="font-size: 15px">구독회원</span>
                  <br />
                  <strong class="h4">{{
                    userStatistics.user_company_Count | numberComma
                  }}</strong>
                </div>
              </b-col>
              <b-col sm="3">
                <div class="callout callout-warning">
                  <span class="text-muted" style="font-size: 15px">휴면회원</span><br />
                  <strong class="h4">{{
                    userStatistics.user_noActive_Count | numberComma
                  }}</strong>
                </div>
              </b-col>
              <b-col sm="3">
                <div class="callout callout-danger">
                  <span class="text-muted" style="font-size: 15px">총회원수</span>
                  <br />
                  <strong class="h4">{{
                    userStatistics.totalCount | numberComma
                  }}</strong>
                </div>
              </b-col>
            </b-row>
            <hr class="mt-0" />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { EventBus } from "../../../event-bus";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "userStatus",
  components: {},
  props: {
    queryParams: {},
    fullDate: {
      type: Array,
    },
  },
  created() {
    // 이벤트 버스 선언
    EventBus.$on("callUserStatistics", () => {
      this.getUserStatistics();
    });
  },
  data() {
    return {
      userStatistics: {
        femaleCount: 0,
        maleCount: 0,
        user_General_Count: 0,
        user_pannel_Count: 0,
        user_active_Count: 0,
        user_company_Count: 0,
        user_noActive_Count: 0,
        user_authority_Count: 0,
        letter_y_Count: 0,
        letter_n_Count: 0,
        totalCount: 0,
      },
      statusLoding: false,
    };
  },
  mounted() {
    this.getUserStatistics();
  },
  methods: {
    getUserStatistics() {
      this.statusLoding = true;
      // console.log('getUserStatistics! queryParams : ', this.queryParams, this.fullDate);
      var token = sessionStorage.getItem("myToken");

      this.queryParams.startDate = this.$parent.getFormatDate(this.fullDate[0]);
      this.queryParams.endDate = this.$parent.getFormatDate(this.fullDate[1]);

      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append("objs", param);

      this.$http
        .post("/api/select/reportStatistics?access_token=" + token, data, null)
        .then((result) => {
          this.userStatistics = result.data;
          this.statusLoding = false;
        });
    },
  },
  components: {
    PulseLoader,
  }
};
</script>
<style scoped>
.status-card .card-body {
  padding-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/user/userList/component/UserStatus.vue